import { ENTITY_LINK_PERMISSIONS, ENTITY_RECORD_DESCRIPTORS, isEntityLinkKind } from "~/shared/ai/entity-link";
import { type RBACPermission } from "~/shared/types/RBACPermission";

export { entityLinkAllowed } from "~/shared/ai/entity-link";

export interface EntityDrillTarget {
  href: string;
  label: string;
}

export const entityDrillTarget = (kind: unknown, id: unknown, number?: unknown, routeId?: unknown): EntityDrillTarget | null => {
  if (typeof id !== "string" || id.length === 0 || !isEntityLinkKind(kind)) {
    return null;
  }
  const entry = ENTITY_RECORD_DESCRIPTORS[kind];
  const href = entry.href(id, typeof number === "string" ? number : undefined, typeof routeId === "string" ? routeId : undefined);
  return href ? { href, label: entry.label } : null;
};

export const entityDrillPermissions = (kind: unknown): RBACPermission[] | null =>
  isEntityLinkKind(kind) ? ENTITY_LINK_PERMISSIONS[kind] : null;
